import { useEffect, useState } from 'react';

const FALLBACK_HEIGHT = '100dvh';

const readVisibleViewportHeight = (): string => {
  const height = window.visualViewport?.height;
  const scale = window.visualViewport?.scale ?? 1;
  // Multiplying by scale keeps the height stable while pinch-zoomed
  return height === undefined ? FALLBACK_HEIGHT : `${height * scale}px`;
};

/**
 * Height of the part of the screen that is actually visible. Unlike `100vh`,
 * it shrinks when the mobile browser toolbar or on-screen keyboard is shown.
 */
export const useVisibleViewportHeight = (): string => {
  const [height, setHeight] = useState(readVisibleViewportHeight);

  useEffect(() => {
    const { visualViewport } = window;
    const handleResize = () => setHeight(readVisibleViewportHeight());

    visualViewport?.addEventListener('resize', handleResize);
    // The viewport may have changed between the first render and now
    handleResize();
    return () => visualViewport?.removeEventListener('resize', handleResize);
  }, []);

  return height;
};
